// extracted by mini-css-extract-plugin
export default {"section-container":"styles__section-container--6TJSi","section-children-container":"styles__section-children-container--0greP"};